export default __webpack_public_path__ + "static/media/gallery_04.75c4c700.jpg";